import * as fragments from './fragments'
export const Hero = groq`_type == 'Hero' =>{
    theme,
    title,
    text[] {
      ...${fragments.portableTextSimple},
    },
    ${fragments.media},
  }
`
export const HeroFullMedia = groq`_type == 'HeroFullMedia' =>{
  text[]{
    ...${fragments.portableTextSimple},
  },
  callToAction[] {
    _type == "link" => ${fragments.callToAction},
  },
  ${fragments.media},
  icons
}`

export const HeroDualMedia = groq`_type == 'HeroDualMedia' =>{
  text[]{
    ...${fragments.portableTextSimple},
  },
  callToAction[] {
    _type == "link" => ${fragments.callToAction},
  },
  medias[]{
    ...${fragments.mediaLight},
  },
  icons
}`

export const NumberedList = groq`_type == 'NumberedList' =>{
  theme,
  trumpet,
    title,
    items[] {
          title,
          callToAction[] {
                _type == "link" => ${fragments.callToAction},
          },
          text[]{
            ...${fragments.portableTextSimple},
          },
    },
  }
`
export const Cta = groq`_type == 'Cta' =>{
  theme,
  trumpet,
    title,
    items[] {
          title,
          text[]{
            ...${fragments.portableTextSimple},
          },
    callToAction{
          _type == "link" => ${fragments.callToAction},
    },
    },
  }
`
export const BigHeading = groq`_type == 'BigHeading' =>{
  theme,
  trumpet,
   text[]{ 
      ...${fragments.portableTextMedia} 
      },
    ${fragments.overlays},
  }
`
export const BigHeadingWithMedia = groq`_type == 'BigHeadingWithMedia' =>{
  theme,
    trumpet,
    text,
    ${fragments.media},
    ${fragments.overlays},
  }
`
export const SplitScreen = groq`_type == 'SplitScreen' =>{
  theme,
  trumpet,
    title,
    subHeading[]{
      ...${fragments.portableTextSimple},
    },
    text[]{
      ...${fragments.portableTextSimple},
    },
    ${fragments.media},
    ${fragments.overlays},
    layout,
  }
`
export const Labs = groq`_type == 'Labs' => {
  theme,
  trumpet,
  title,
  carousel[] {
    'title': @->title,
    'text': @->text,
    'media': @->media {
      ...${fragments.mediaLight},
    },
    'callToAction': @->callToAction[] {
      ...${fragments.callToAction},
    }
  },
  ${fragments.overlays},
}`

export const DualMedia = groq`_type == 'DualMedia' =>{
      mediaLeft{
        ...${fragments.mediaLight},
      },
      mediaRight{
        ...${fragments.mediaLight},
      },
  }
`
export const CenteredMedia = groq`_type == 'CenteredMedia' =>{
  theme,
      showVideoControls,
      ${fragments.media},
  }
`
export const FullWidthMedia = groq`_type == 'FullWidthMedia' =>{
  ...,
  theme,
  showVideoControls,
  showTextAnimation,
  ${fragments.overlays},
  ${fragments.media},
  ${fragments.mediaMobile},
}`

export const Logos = groq`_type == 'Logos' =>{
  theme,
  logos[]{
    ...${fragments.logo},
  },
}`

// ...${fragments.media},
export const MediaCarousel = groq`_type == 'MediaCarousel' => {
  theme,
  medias[]{
    ...,
    image {
      ...,
      ...asset-> {
      altText,
      ...metadata {
        lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
        ...dimensions {
          width,
          height
        },
      },
    },
    }, 
      video {
        asset-> {
          playbackId,
          assetId,
          filename,
          "duration": data.duration,
          thumbTime,
        },
      },
    },
}`

export const SectionTitle = groq`_type == 'SectionTitle' =>{
  theme,
  title,
  indicator,
}`

export const Text = groq`_type == 'Text' =>{
  theme,
  subHeading[] {
    ...${fragments.portableTextSimple}
  },
  text[] {
    ...${fragments.portableTextSimple}
  },
  callToAction[] {
      _type == "link" => ${fragments.callToAction},
    },
}`

export const Accordion = groq`_type == 'Accordion' =>{
  theme,
  title,
  subHeading[] {
    ...${fragments.portableTextSimple},},
  text[] {
    ...${fragments.portableTextSimple},},
  indicator,
  ${fragments.media},
}`

export const Quote = groq`_type == 'Quote' =>{
  theme,
      quote[]{
      ...${fragments.portableTextSimple},
    },
      quotee,
  }
`
export const Stats = groq`_type == 'Stats' => {
  theme,
  stats[] {
    title,
    text,
  },
  bigNumbers,
}`
export const Locations = groq`_type == 'Locations' => {
  theme,
  trumpet,
  title,
  map[] {
    title,
    text[]{
      ...${fragments.portableTextSimple},
    },
    callToAction[] {
      _type == "link" => ${fragments.callToAction},
    },
    'x': X,
    'y': Y
  }
}`

export const People = groq`_type == 'People' =>{
  theme,
  crop,
  people[]{
    _type == 'reference' => {
    'title':  @->title,
     'position': @->position,
     'phone': @->phone,
      'email': @->email,
     'media' :@->media{
        ...${fragments.mediaLight},
      },
    },
  }
}
`
export const Timeline = groq`_type == 'Timeline' =>{
  theme,
  timelineItems[]{
    _type == 'reference' => {
      'title':  @->title,
      'month': @->month,
      'year': @->year,
      'text': @->text,
    },
  }
}`

export const FormQuery = groq`_type == 'Form' => {
  theme,
  type
}`

export const Factory = groq`_type == 'Factory' => {
  theme,
  factory[] {
    _type == 'reference' => {
      'name':  @->name,
      'description': @->description,
       'media' :@->media{
        ...${fragments.mediaLight},
      },
      'callToAction': @->callToAction[] {
        ...${fragments.callToAction},
      },
    },
  },
}`

export const blogSectionQuery = groq`_type == 'blogSection' => {
  theme,
  crop,
  allBlogs[] {
    _type == 'reference' => {
      'title': @->title,
      'slug': @->slug.current,
      'category': @->category,
      'text': @->text[]{
        ...${fragments.portableTextMultiple}
      },
      'date': @->date,
      'media': @->media{
        ...${fragments.mediaLight},
      },
    },
  },
}`

// Page sections query
export const builder = groq`
  pageSections[] {
    _type,
    'id': _key,
    'data': {
      ${CenteredMedia},
      ${Cta},
      ${FullWidthMedia},
      ${HeroFullMedia},
      ${HeroDualMedia},
      ${NumberedList},
      ${Logos},
      ${MediaCarousel},
      ${BigHeadingWithMedia},
      ${Accordion},
      ${Hero},
      ${Quote},
      ${Stats},
      ${Text},
      ${Timeline},
      ${SectionTitle},
      ${People},
      ${DualMedia},
      ${SplitScreen},
      ${Labs},
      ${Locations},
      ${BigHeading},
      ${FormQuery},
      ${Factory},
      ${blogSectionQuery},
    },
  }
`
